import React from 'react';
import { SimpleShowLayout } from 'react-admin';
import AccountsTab from 'components/tabs/AccountsTab';

const LocationAccountsTab = (props) => (
  <SimpleShowLayout>
    <AccountsTab target="location_id" {...props} />
  </SimpleShowLayout>
);

export default LocationAccountsTab;
